import { render, staticRenderFns } from "./SecondaryDeviceEdit.vue?vue&type=template&id=50840710&scoped=true"
import script from "./SecondaryDeviceEdit.vue?vue&type=script&lang=js"
export * from "./SecondaryDeviceEdit.vue?vue&type=script&lang=js"
import style0 from "./SecondaryDeviceEdit.vue?vue&type=style&index=0&id=50840710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50840710",
  null
  
)

export default component.exports